import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

const Button = ({ text, to, onClick, type = 'button', className = '' }) => {
    const buttonContent = (
        <span className={`custom-button ${className}`}>
            {text}
        </span>
    );

    if (to) {
        return (
            <Link to={to} style={{ textDecoration: 'none' }}>
                {buttonContent}
            </Link>
        );
    }

    return (
        <button type={type} onClick={onClick} className="button-reset">
            {buttonContent}
        </button>
    );
};

export default Button;
